import React from 'react';
import TaskForm from '../../Components/AddNewComponents/TaskForm';
import { useGetProjectsQuery } from '../../features/projects/projectsApi';
import { useGetTeamQuery } from '../../features/team/teamApi';

const AddNew = () => {
    const { data: teams, isLoading: teamLoading, } = useGetTeamQuery()
    const { data: projects, isLoading: projectLoading } = useGetProjectsQuery()

    let content = null;
    if (teamLoading || projectLoading) {
        content = <div>Loading...</div>
    } else {
        content = <TaskForm projects={projects} teams={teams}></TaskForm>
    }

    return (
        <div className="container relative">
            <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
                <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
                    Create Task for Your Team
                </h1>

                <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
                    {content}
                </div>
            </main>
        </div>
    );
};

export default AddNew;